import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { ProspectDetails_FieldsFragmentDoc } from './sales-portal-prospect-details-fragments.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalProspectStageDocument = gql`
  query SalesPortalProspectStage($restaurantUUID: uuid!, $supplierUUID: uuid!) {
    prospectDetails: getSalesPortalProspectDetails(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...ProspectDetails_Fields
    }
  }
  ${ProspectDetails_FieldsFragmentDoc}
`;
export function useSalesPortalProspectStageQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >(SalesPortalProspectStageDocument, options);
}
export function useSalesPortalProspectStageLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >(SalesPortalProspectStageDocument, options);
}
export type SalesPortalProspectStageQueryHookResult = ReturnType<
  typeof useSalesPortalProspectStageQuery
>;
export type SalesPortalProspectStageLazyQueryHookResult = ReturnType<
  typeof useSalesPortalProspectStageLazyQuery
>;
export type SalesPortalProspectStageQueryResult = Apollo.QueryResult<
  Types.SalesPortalProspectStageQuery,
  Types.SalesPortalProspectStageQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalProspectStageQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalProspectStageQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >(SalesPortalProspectStageDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalProspectStageLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalProspectStageLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalProspectStageQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalProspectStageQuery,
    Types.SalesPortalProspectStageQueryVariables
  >(SalesPortalProspectStageDocument, lazyOptions);
}
